import { Button } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

import { PLAN_PAGE } from 'src/constants';
import { useSettingsPageRedirection } from 'src/legacy/components/Settings/useSettingsPageRedirection';
import BaseTypography, {
  typography12MediumStyle,
} from 'src/legacy/components/Text/BaseTypography';
import { useRouteAccess } from 'src/routes/routeAccess';
import * as Colors from 'src/theme/colors';

const useStyles = makeStyles()(() => ({
  button: {
    backgroundColor: Colors.white,
    textDecoration: 'underline',
    ...typography12MediumStyle,

    '&:hover': {
      backgroundColor: Colors.white,
      textDecoration: 'underline',
    },
  },
}));

/** Static copy + plans link for already-installed apps locked by a Freemium overage. */
export const AppLimitTooltipTitle: FC = () => {
  const { classes } = useStyles();

  const { routeAccess } = useRouteAccess();

  const { goToSettings: goToPlansSettings } = useSettingsPageRedirection(
    true,
    PLAN_PAGE.path,
  );

  const onUpgradePlan = () => goToPlansSettings();

  return (
    <BaseTypography fontType="12Medium" style={{ color: Colors.BlackHeadings }}>
      {routeAccess.allowSettingsPlanPage ? (
        <>
          <span>You&apos;ve reached your app limit. </span>
          <Button
            variant="text"
            onClick={onUpgradePlan}
            className={classes.button}
          >
            Upgrade your plan
          </Button>
        </>
      ) : (
        <span>
          You&apos;ve reached your app limit. Ask your account admin to upgrade
          your plan
        </span>
      )}
    </BaseTypography>
  );
};
